import { get, create, update } from './common';

export default {
    getWatchList: async (params, token) => get(`/v1/Auction/GetWatchList`, token),
    addWatchList: async (params, token) => create(`/v1/Auction/AddWatchList`, params, token),
    removeWatchList: async (params, token) => update(`/v1/Auction/RemoveWatchList`, params, token),
};